
import * as tripApis from "../apis/trip_apis";
import { MAX_ALLOWED_LENGTH, MAX_ALLOWED_WAYPOINTS} from "../utils/commons";
import * as emailValidator from "email-validator";

//action constants
const TRIP_CHANGE = "tripChange";
const TRIP_WAYPOINT_CHANGE = "tripWayPointChange";
const TRIP_ADD_WAYPOINT = "tripAddWayPoint";
const TRIP_DELETE_WAYPOINT = "tripDeleteWayPoint";
const TRIP_RESET_WAYPOINT = "tripResetWayPoint";
const TRIP_RESET = "tripReset";
const TRIP_SUBMITTING = "tripSubmitting";
const TRIP_SUBMITTED = "tripSubmitted";
export const TRIP_ON_VALIDATE = "tripOnValidate";
const TRIP_LOAD = "loadTrip";
const TRIP_LOADED = "loadedTrip";
const TRIP_ACTION_SUBMITTING = "tripActionSubmitting";
const TRIP_ACTION_SUBMITTED = "tripActionSubmitted";


const initTripErrors = () => ({
    notes: "",
    wayPoints: "",
    driversEmails: "",
});

const initWayPoint = {
    name: "",
    location: {latLong: "",
               streetAddress: ""},
};

const initState = () => ({
    tripCode: "",
    createDate: "",
    wayPoints: [],
    submitting: false,
    notes: "",
    error: "",
    info: "",
    driversEmails: "",
    tripErrors: initTripErrors(),
    currentWayPoint: initWayPoint,
    loading: false,
    loadError: "",
    currentTrip: {
        wayPoints: [],
        driversEmails: [],
        notes: "",
        createDate: "",
        status: "",
        tripCode: "",
    },
})

const mutations = {
    [TRIP_CHANGE] (state, payload) {
        Object.assign(state, {[payload.name]:payload.value});
    },
    [TRIP_WAYPOINT_CHANGE] (state, payload) {
        state.currentWayPoint = {...state.currentWayPoint, [payload.name]:payload.value}
    },
    [TRIP_ADD_WAYPOINT] (state) {
        state.wayPoints = state.wayPoints.filter(item => item.name !== state.currentWayPoint.name);
        state.wayPoints.push(state.currentWayPoint);
    },
    [TRIP_DELETE_WAYPOINT] (state, name) {
        state.wayPoints = state.wayPoints.filter(item => item.name !== name);
    },
    [TRIP_RESET_WAYPOINT] (state) {
        state.currentWayPoint = initWayPoint;
    },
    [TRIP_RESET] (state) {
        /* eslint-enable no-unused-vars */
        Object.assign(state, initState())
    },
    [TRIP_SUBMITTING] (state) {
        Object.assign(state, {submitting: true, info: "", error: ""});
    },
    [TRIP_SUBMITTED] (state, payload) {
        Object.assign(state, {submitting: false, info: payload.info, error: payload.error});
    },
    [TRIP_ACTION_SUBMITTING] (state) {
        Object.assign(state, {submitting: true, info: "", error: ""});
    },
    [TRIP_ACTION_SUBMITTED] (state, payload) {
        Object.assign(state, {submitting: false, info: payload.info, error: payload.error, currentTrip: payload.currentTrip});
    },
    [TRIP_ON_VALIDATE] (state, payload) {
        Object.assign(state, {tripErrors: {...payload}});
    },
    [TRIP_LOAD] (state) {
        Object.assign(state, {loading: true, loadError: ""});
    },
    [TRIP_LOADED] (state, payload) {
        Object.assign(state, {loading: false, currentTrip: payload.currentTrip, error: payload.error});
    },
};

const actions = {
    updateTrip ({commit}, payload) {
        commit(TRIP_CHANGE, payload);
    },
    updateWayPoint({commit}, payload) {
        commit(TRIP_WAYPOINT_CHANGE, payload);
    },
    addWayPoint({commit}) {
        commit(TRIP_ADD_WAYPOINT);
        commit(TRIP_RESET_WAYPOINT);
    },
    [TRIP_DELETE_WAYPOINT]({commit}, name) {
        commit(TRIP_DELETE_WAYPOINT, name);
    },
    submitTrip({commit, state}) {
        commit(TRIP_SUBMITTING);

        let trip = {wayPoints: state.wayPoints,
                    notes: state.notes,
                    driversEmails: state.driversEmails.split(",")};

        tripApis.submitTrip(trip)
            .then((results) => {
                let info = !trip.error? "Trip submitted with code: "+results.tripCode : "";
                commit(TRIP_SUBMITTED, {info: info, error: results.error})
                },
                (results) => {
                let error = !results.error? "Trip failed to submit. Try again later.": results.error;
                commit(TRIP_SUBMITTED, {info: "", "error": error});
                })
    },
    resetTrip({commit}) {
        commit(TRIP_RESET);
    },
    [TRIP_ON_VALIDATE] ({commit, state}) {
        let errors = {};

        if(state.wayPoints.length < 1 || state.wayPoints.length > MAX_ALLOWED_WAYPOINTS) {
            errors.wayPoints = "Please enter valid number of waypoints";
        }

        if( state.notes.length > MAX_ALLOWED_LENGTH) {
            errors.notes = "Please enter valid notes";
        }

        if( state.driversEmails) {
            const someEmails = state.driversEmails.split(",").some(email => !email || !emailValidator.validate(email));
            if(someEmails) {
                errors.driversEmails = "Please check all emails valid.";
            }
        }

        commit(TRIP_ON_VALIDATE, errors);
        if(Object.keys(errors).length > 0) {
            commit(TRIP_CHANGE, {name: "error", value: "Please ensure trip is valid"});
        }else {
            commit(TRIP_CHANGE, {name: "error", value: ""});
        }
    },

    retriveTrip({commit}, tripCode) {

        if(!tripCode || tripCode == -1) {
            return;
        }

        commit(TRIP_LOAD);

        tripApis.retrieveTripByCode(tripCode)
            .then((results) => {
                    commit(TRIP_LOADED, {currentTrip: results})
                },
                (results) => {
                    let error = !results.error? "Failed to load trip. Try again later.": results.error;
                    commit(TRIP_SUBMITTED, {info: "", "error": error});
                })
    },
    updateTripStatus({commit, state}, payload) {

        if(!payload.statusCode || !state.currentTrip.tripCode) {
            return;
        }

        commit(TRIP_ACTION_SUBMITTING);

        tripApis.updateStatus(state.currentTrip.tripCode, payload.statusCode)
            .then((results) => {
                    commit(TRIP_ACTION_SUBMITTED, {currentTrip: results});
                    if(payload.callback && typeof payload.callback === "function") {
                        payload.callback();
                    }
                },
                (results) => {
                    let error = !results.error? "Failed to update trip.": results.error;
                    commit(TRIP_ACTION_SUBMITTED, {info: "", "error": error});
                    if(payload.callback && typeof payload.callback === "function") {
                        payload.callback();
                    }
                })
    },
}

const tripStore = {
    state: initState(),
    mutations: mutations,
    actions: actions,
}

export default tripStore
